export default function maybeIOS(deviceInfo) {
  var touchDevice = typeof document !== "undefined" && "ontouchend" in document; //この関数はSSRしないページで呼ばれることは現在ないが、一応deviceInfoの参照にオプショナルをつけておく

  return touchDevice && (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMac) || (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isIOS);
}
export function maybeIPad(deviceInfo) {
  var touchDevice = typeof document !== "undefined" && "ontouchend" in document;
  return touchDevice && (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMac);
}